module.exports = __webpack_public_path__ + "img/enoughFundsVisa.e0ac4f5f.png";